import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const DefaultReviewersLoadable = Loadable({
  loading: LoadingPage,
  loader: () =>
    import(/* webpackChunkName: "branching-model" */ './default-reviewers'),
});
